import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloError } from 'apollo-client';
import { defineMessages, FormattedMessage } from 'react-intl-next';
// We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/core';

import { token } from '@atlaskit/tokens';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { R300, N100 } from '@atlaskit/theme/colors';

import { ErrorDisplay } from '@confluence/error-boundary';

const i18n = defineMessages({
	error: {
		id: 'space-directory.error.message',
		defaultMessage: 'We’re having trouble loading the spaces. Try refreshing the page.',
		description:
			'Shown when Space directory fails to load initially OR fails to load additional spaces',
	},
});

export const ErrorMessage: FC<{ apolloError?: ApolloError }> = ({ apolloError }) => (
	<Fragment>
		{apolloError && <ErrorDisplay error={apolloError} />}
		{!apolloError?.extraInfo?.isWatchedError ? (
			<div
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
				css={css`
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: ${token('space.250', '20px')};
					color: ${token('color.text.subtle', N100)};
				`}
			>
				<WarningIcon primaryColor={token('color.icon.danger', R300)} label="" />
				<FormattedMessage {...i18n.error} />
			</div>
		) : null}
	</Fragment>
);
